module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0007-3d88a45ed15324482923542dcb3a1cb3.jpg";